import ImageMeta from './ImageMeta.js'

export default {
  questions: [
    { // 0
      img: ImageMeta.fixation.dynamic.examples[0].url,
      choices: {
        'Dynamic compression screw': true,
        'Spiral blade': false,
        'Blade-plate': false,
        'Hagie pin': false
      }
    },
    { // 1
      img: ImageMeta.fixation.spiral.examples[0].url,
      choices: {
        'Dynamic compression screw': false,
        'Spiral blade': true,
        'Blade-plate': false,
        'Hagie pin': false
      }
    },
    { // 2
      img: ImageMeta.fixation.exfix.examples[0].url,
      choices: {
        'External fixation': true,
        'Cast': false,
        'Splint': false,
        'Arthrodesis': false
      }
    },
    { // 3
      img: ImageMeta.fixation.imnail.examples[0].url,
      choices: {
        'Intramedullary nail': true,
        'Plate-screw fixation': false,
        'Spiral blade': false,
        'Dyanmic compression screw': false
      }
    },
    { // 4
      img: ImageMeta.hip.spacer.examples[0].url,
      choices: {
        'Articulating antibiotic spacer': true,
        'Unipolar hemi-arthroplasty': false,
        'Bipolar hemi-arthroplasty': false,
        'Total hip arthroplasty': false
      }
    },
    { // 5
      img: ImageMeta.hip.bipolar.examples[0].url,
      choices: {
        'Articulating antibiotic spacer': false,
        'Unipolar hemi-arthroplasty': false,
        'Bipolar hemi-arthroplasty': true,
        'Total hip arthroplasty': false
      }
    },
    { // 6
      img: ImageMeta.hip.total.examples[0].url,
      choices: {
        'Articulating antibiotic spacer': false,
        'Unipolar hemi-arthroplasty': false,
        'Bipolar hemi-arthroplasty': false,
        'Total hip arthroplasty': true
      }
    },
    { // 7
      // TODO: change this question to constrained vs non
      img: ImageMeta.knee.nostemtotal.examples[0].url,
      choices: {
        'No stem total arthroplasty': true,
        'ACL repair': false,
        'Short stem total arthroplasty': false,
        'Unicompartmental arthroplasty': false
      }
    },
    { // 8
      img: ImageMeta.shoulder.reverse.examples[0].url,
      choices: {
        'Reverse total arthroplasty': true,
        'Resurfacing hemiarthroplasty': false,
        'Total arthroplasty': false,
        'Articulating antibiotic spacer': false
      }
    },
    { // 9
      img: ImageMeta.shoulder.total.examples[0].url,
      choices: {
        'Reverse total arthroplasty': false,
        'Resurfacing hemiarthroplasty': false,
        'Total arthroplasty': true,
        'Articulating antibiotic spacer': false
      }
    },
    { // 10
      img: ImageMeta.failure.dislocation.examples[0].url,
      choices: {
        'Dislocation': true,
        'Loosening': false,
        'Hardware fracture': false,
        'Polyethylene wear': false
      }
    },
    { // 11
      img: ImageMeta.failure.wear.examples[1].url,
      choices: {
        'Dislocation': false,
        'Loosening': false,
        'Hardware fracture': false,
        'Polyethylene wear': true
      }
    },
    { // 12
      img: ImageMeta.failure.hardwarefx.examples[0].url,
      choices: {
        'Hardware fracture': true,
        'Heterotopic bone': false,
        'Loosening': false,
        'Dislocation': false
      }
    },
    { // 13
      img: ImageMeta.failure.heterotopic.examples[0].url,
      choices: {
        'Heterotopic bone': true,
        'Periprosthetic fracture': false,
        'Dislocation': false,
        'Arthrofibrosis': false
      }
    },
    { // 14
      img: ImageMeta.failure.loosening.examples[9].url,
      choices: {
        'Subsidence': true,
        'Hardware fracture': false,
        'Dislocation': false,
        'Arthrofibrosis': false
      }
    },
    { // 15
      img: ImageMeta.failure.loosening.examples[10].url,
      choices: {
        'Loosening': true,
        'Dislocation': false,
        'Hardware fracture': false,
        'Arthrofibrosis': false
      }
    },
    { // 16
      img: ImageMeta.failure.periprostheticfx.examples[1].url,
      choices: {
        'Periprosthetic fracture': true,
        'Heterotopic bone': false,
        'Dislocation': false,
        'Loosening': false
      }
    },
    { // 17
      stem: 'The interlocking screws shown are intended to prevent:',
      img: ImageMeta.fixation.imnail.examples[0].url,
      choices: {
        'Rotation and shortening': true,
        'Loosening': false,
        'Dynamic compression': false,
        'Dislocation': false
      }
    },
    { // 18
      stem: 'Bipolar hemiarthroplasty is best used for:',
      img: ImageMeta.hip.bipolar.examples[0].url,
      choices: {
        'Femoral neck fracture with preserved acetabulum': true,
        'Revision arthroplasty': false,
        'Infected joints': false,
        'Degenerative arthrosis': false
      }
    },
    { // 19
      img: ImageMeta.fixation.tension.examples[1].url,
      choices: {
        'Tension wire': true,
        'Cerclage band': false,
        'Percutaneous pin': false,
        'External fixation': false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Quiz.js